import { render, staticRenderFns } from "./Notions.vue?vue&type=template&id=dcf23918"
import script from "./Notions.vue?vue&type=script&lang=js"
export * from "./Notions.vue?vue&type=script&lang=js"
import style0 from "./Notions.vue?vue&type=style&index=0&id=dcf23918&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports